import React, {ReactElement} from "react";
import "./css/NavBar.scss";
import {Button, IconButton, Typography} from "@mui/material";
import {Dashboard, Engineering, Google, KeyboardArrowLeft, Settings} from "@mui/icons-material";
import useAppContext from "../../util/AppContext";
import css_self from "./css/NavBar.module.scss";
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDiamond} from "@fortawesome/free-solid-svg-icons";
import s3 from "../../assets/s3.png";
import {Blue3} from "../../theme/styles";

export default function GlobalMenu() {
    const appContext = useAppContext();
    const navigate = useNavigate();

    let content: ReactElement | null = (
        <div style={{display: "flex", flexDirection: "column", width: "250px", height: "100vh", borderRight: "1px solid #EDEFF3"}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "0px 10px 0px 25px", backgroundColor: "#EDEFF3", height: "52px"}}>
                <div style={{marginTop: "11px"}}>
                    <Typography style={{fontSize: "20px", fontWeight: "500", color: "#000000"}}>Enlil</Typography>
                </div>
                <div style={{marginTop: "4px"}}>
                    <IconButton onClick={() => {
                        appContext?.sessionContext?.setShowGlobalMenu(false);
                    }}>
                        <KeyboardArrowLeft/>
                    </IconButton>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", paddingTop: "25px", marginLeft: "20px"}}>
                <div>
                    <Dashboard sx={{color: "#7B8291", width: "25px", height: "25px"}}/>
                </div>
                <div style={{marginTop: "-7px", marginLeft: "10px"}}>
                    <Button className={css_self.NavMenuButton} style={{fontSize: "14px"}} variant="text" onClick={() => navigate("/dashboard")}>Dashboard</Button>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", paddingTop: "10px", marginLeft: "20px"}}>
                <div>
                    <Settings sx={{color: "#7B8291", width: "25px", height: "25px"}}/>
                </div>
                <div style={{marginTop: "-7px", marginLeft: "10px"}}>
                    <Button className={css_self.NavMenuButton} style={{fontSize: "14px"}} variant="text" onClick={() => navigate("/jobs")}>Jobs</Button>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", paddingTop: "10px", marginLeft: "20px"}}>
                <div>
                    <Engineering sx={{color: "#7B8291", width: "25px", height: "25px"}}/>
                </div>
                <div style={{marginTop: "-7px", marginLeft: "10px"}}>
                    <Button className={css_self.NavMenuButton} style={{fontSize: "14px"}} variant="text" onClick={() => navigate("/executions")}>Executions</Button>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "3px 10px 0px 25px", marginTop: "30px", backgroundColor: "#EDEFF3", height: "25px"}}>
                <Typography style={{fontSize: "14px", fontWeight: "500", color: "#7B8291"}}>Data Sources</Typography>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", paddingTop: "25px", marginLeft: "20px"}}>
                <div>
                    <Google sx={{color: "#7B8291", width: "25px", height: "25px"}}/>
                </div>
                <div style={{marginTop: "-7px", marginLeft: "10px"}}>
                    <Button className={css_self.NavMenuButton} style={{fontSize: "14px"}} variant="text" onClick={() => navigate("/google")}>Google Drive</Button>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", paddingTop: "10px", marginLeft: "20px"}}>
                <div>
                    <FontAwesomeIcon icon={faDiamond} style={{color: "#7B8291", width: "25px", height: "25px", marginTop: "2px"}}/>
                </div>
                <div style={{marginTop: "-7px", marginLeft: "10px"}}>
                    <Button className={css_self.NavMenuButton} style={{fontSize: "14px"}} variant="text" onClick={() => navigate("/executions")}>Dropbox</Button>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", paddingTop: "10px", marginLeft: "20px"}}>
                <div>
                    <img alt={"S3"} src={s3} style={{color: Blue3, width: "35px", height: "35px", marginLeft: "-5px"}}/>
                </div>
                <div style={{marginTop: "-7px", marginLeft: "0px"}}>
                    <Button className={css_self.NavMenuButton} style={{fontSize: "14px"}} variant="text" onClick={() => navigate("/s3")}>S3</Button>
                </div>
            </div>
        </div>
    )

    if (!appContext?.sessionContext?.getShowGlobalMenu()) {
        content = null;
    }

    return (
        <>{content}</>
    );

}
